<template>
	<span class="uncategorized" v-t="'admin_categories_uncategorized_label'" />
</template>

<script>
export default {
	name: 'Uncategorized',
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

span.uncategorized {
	color: var(--neutral-400);
	font-size: 16px;
	font-family: Avenir-Oblique;
	padding-right: 4px; // ensures the 'd' at end of word isn't cut off
}
</style>
